import { Link } from "react-router-dom";
import { MessageSquareText, BookOpen, Building2, FileText, Compass, ListChecks, ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ITEMS = [
  { key: "solver", icon: MessageSquareText, to: "/solve", span: "lg:col-span-2", dark: true },
  { key: "learn", icon: BookOpen, to: "/solve", state: { category: "learn" } },
  { key: "campus", icon: Building2, to: "/solve", state: { category: "result" } },
  { key: "docs", icon: FileText, to: "/docs", span: "lg:col-span-2" },
  { key: "career", icon: Compass, to: "/solve", state: { category: "career" }, partial: true },
  { key: "track", icon: ListChecks, soon: true },
];

const Card = ({ item, index }) => {
  const { t } = useLang();
  const [title, desc] = t(`services.${item.key}`);
  const Icon = item.icon;
  const tone = item.dark ? "bg-navy text-white border-navy" : "bg-white text-navy border-navy/10";
  const inner = (
    <>
      <div className="flex items-start justify-between">
        <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${item.dark ? "bg-white/10 text-cyan" : "bg-cyan-soft text-brand"}`}>
          <Icon className="h-6 w-6" />
        </span>
        {(item.soon || item.partial) && (
          <span className="rounded-full bg-amber-100 px-2.5 py-1 text-[11px] font-semibold text-amber-800">{t("services.soon")}</span>
        )}
      </div>
      <div className="mt-10">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className={`mt-2 text-sm leading-relaxed ${item.dark ? "text-white/75" : "text-navy/65"}`}>{desc}</p>
        {!item.soon && (
          <span className={`mt-5 inline-flex items-center gap-1.5 text-sm font-semibold ${item.dark ? "text-cyan" : "text-brand"}`}>
            {t("services.open")} <ArrowRight className="h-4 w-4" />
          </span>
        )}
      </div>
    </>
  );
  const cls = `flex flex-col justify-between rounded-3xl border p-7 animate-fade-up ${tone} ${item.span || ""}`;
  if (item.soon) return <div className={cls} style={{ animationDelay: `${index * 70}ms` }} data-testid={`service-card-${item.key}`}>{inner}</div>;
  return (
    <Link to={item.to} state={item.state} className={`card-lift ${cls}`} style={{ animationDelay: `${index * 70}ms` }} data-testid={`service-card-${item.key}`}>
      {inner}
    </Link>
  );
};

export const Services = () => {
  const { t } = useLang();
  return (
    <section className="bg-white py-20" aria-labelledby="services-title" data-testid="services-section">
      <div className="container-z">
        <p className="eyebrow">{t("services.eyebrow")}</p>
        <h2 id="services-title" className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">{t("services.title")}</h2>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item, i) => <Card key={item.key} item={item} index={i} />)}
        </div>
      </div>
    </section>
  );
};
